<template>
    <span>
        <TInput
            :hidden="op == 'is_null'"
            step="1"
            :value="value" 
            type='number'
            @input.stop="e => $emit('input', e.target.value)"></TInput>
    </span>
</template>
<script>
import { TInput } from '@roonlabs/vue-tailwind';
export default {
    components: {TInput},
    name: 'IntegerInput',
    props: {
        value: {
            type: Number,
            default: 0
        },
        op: {
            type: String,
            default: null
        }
    }
}
</script>
